import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PageTitleDirective } from '@directives/page-title/page-title.directive';
import { TranslationPipe } from '@pipes/translation/translation.pipe';

import { GenericErrorComponent } from '../generic-error/generic-error.component';

@Component({
  selector: 'ts-page-not-found',
  templateUrl: './page-not-found.component.html',
  imports: [CommonModule, GenericErrorComponent, TranslationPipe, PageTitleDirective]
})
export class PageNotFoundComponent {}
